import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommunityTestlets = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.3335 9.16666C3.3335 3.98148 4.81566 2.5 10.0005 2.5C15.1853 2.5 16.6668 3.98148 16.6668 9.16666C16.6668 14.3518 15.1284 15.8333 10.0005 15.8333C4.87264 15.8333 3.3335 14.3518 3.3335 9.16666Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.85228 15.8335C6.85228 15.8335 6.66728 12.5 6.66735 9.16675C6.66743 5.8335 6.85254 2.50017 6.85254 2.50017",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.667 15.8336C11.667 17.2201 11.9274 18.3335 12.4482 18.3335C12.9691 18.3335 13.2295 17.2809 13.7503 17.2809C14.2712 17.2809 14.5316 18.3335 15.0524 18.3335C15.5732 18.3335 15.8337 17.2711 15.8337 15.8336C15.8337 15.0088 15.7882 14.4368 15.6022 14.0503",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCommunityTestlets);
export { ForwardRef as ReactComponent };
